import { render, staticRenderFns } from "./bankinput.vue?vue&type=template&id=65fe1731&scoped=true&"
import script from "./bankinput.vue?vue&type=script&lang=js&"
export * from "./bankinput.vue?vue&type=script&lang=js&"
import style0 from "./bankinput.vue?vue&type=style&index=0&id=65fe1731&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe1731",
  null
  
)

export default component.exports